import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
//import DataTableExtensions from 'react-data-table-component-extensions';
import "react-data-table-component-extensions/dist/index.css";
//service
import { CurrencyDecimalFormat } from "../../helper";
import style from "./ilifepoint.module.scss";
import { Filter } from ".";
import moment from "moment";
import ViewDetailsModal from "./ViewDetailsModal";
import Ifern4pService from "../../../service/ifern4p/ifern4p";

function HistorysTable({
  ContentData,
  paginationchange,
  exportData,
  loader,
  selectedTab,
}) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const [viewDetailsModal, setViewDetailsModal] = useState(false);
  const [resultData, setResultData] = useState([]);
  const handleClose = () => {
    setViewDetailsModal(false);
  };

  const handleActionClick = (row) => {
    console.log("inside row click", row);
    const service = new Ifern4pService();
    service.singleCodeListHistory(row.id).then((res) => {
      if (res?.error) {
        console.log("error", res?.error?.description);
        setResultData([]);
      } else {
        console.log("res from single action click", res);
        setResultData(res.data.result);
        setViewDetailsModal(true);
      }
    });
  };

  const { t } = useTranslation();
  const Currency = useSelector((state) => state.curr);
  console.log(ContentData, "content data");
  const customStyles = {
    rows: {
      style: {
        minHeight: "72px", // Sets the height of the rows
      },
    },
    headCells: {
      style: {
        fontSize: "13px", // Sets the font size of the column header
        fontWeight: "bold", // Sets the font weight of the column header
        paddingLeft: "9px", // Adds some padding to the left of the column header
        // backgroundColor: "#F5F5F5", // Sets the background color of the column header
      },
    },
    cells: {
      style: {
        fontSize: "13px", // Sets the font size of the table cells
        paddingLeft: "16px", // Adds some padding to the left of the table cells
      },
    },
  };
  const columns = [
    {
      name: t("Common.expirationdate").toUpperCase(),
      selector: (row) => row.expiration_date,
      // width: "30%",
      cell: (row) => (
        <span
          className={`${
            currentTheme == "theme-dark"
              ? `${style.dark_mode_credit} ${style.badge}`
              : `${style.credit} ${style.badge}`
          }`}
        >
          {moment(row.expiration_date).format("MM-DD-YY")}
        </span>
      ),
      sortable: true,
    },
    {
      name: t("Common.productName").toUpperCase(),
      selector: () => "4P",
      cell: () => (
        <span>
          4P
        </span>
      ),
      sortable: false,
    },
    
    {
      name: t("Common.acv_code").toUpperCase(),
      selector: (row) => row.access_code,
      sortable: true,
    },
    {
      name: t("Common.sec_code").toUpperCase(),
      selector: (row) => row.security_code,
      sortable: true,
    },
    {
      name: t("Common.status").toUpperCase(),
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: t("Common.buv").toUpperCase(),
      selector: (row) => row.pair_value,
      sortable: true,
      // cell: (row) => (
      //   <span className={`${currentTheme == "theme-dark"
      //       ? `${style.dark_mode_credit} ${style.badge}`
      //       : `${style.credit} ${style.badge}`
      //     }`}>
      //     {Currency.currentCurr}{" "}
      //     {CurrencyDecimalFormat(
      //       row.total_amount * Currency.value,
      //       Currency.precision
      //     )}
      //   </span>
      // ),
    },
    {
      name: t("Common.action"),
      selector: (row) => row.id,
      selector: (row) => (
        <u onClick={() => handleActionClick(row)} style={{ cursor: "pointer" }}>
          View Details
        </u>
      ),
    },
    // {
    //   name: t("Common.transactionDate").toUpperCase(),
    //   selector: (row) => row.transaction_date,
    //   sortable: true,
    // },
  ];
  const [state, setState] = useState({ data: [] });
  const [date, SetDate] = useState({
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
    selectedValues: [],
  });

  const { data } = state;

  useEffect(() => {
    if (ContentData.data) {
      let NewData = ContentData.data.map((resData) => {
        return {
          // classnameamount : style.credit,
          expiration_date: resData.expiration_date,
          pair_value: resData.buv,
          access_code: resData.access_code,
          security_code: resData.security_code,
          status: resData.status,
          id: resData.id,
        };
      });
      setState((prev) => ({
        ...prev,
        data: NewData,
      }));
    }
  }, [ContentData]);
  const handlePerRowsChange = (perPage, inPage) => {
    let keys = [];
    date.selectedValues.map((key, idx) => {
      keys.push(key.value);
    });
    // let keys = date.selectedValues
    //   .map((key, idx) => {
    //     return "categories[" + idx + "]=" + key.value;
    //   })
    //   .join("&");
    paginationchange(inPage, perPage, date.start, date.end, "", "", keys);
  };
  const handlePageChange = (inPage) => {
    let keys = [];
    date.selectedValues.map((key, idx) => {
      keys.push(key.value);
    });
    // let keys = date.selectedValues
    //   .map((key, idx) => {
    //     return "categories[" + idx + "]=" + key.value;
    //   })
    //   .join("&");

    paginationchange(
      inPage,
      ContentData.perPage,
      date.start,
      date.end,
      "",
      "",
      keys
    );
  };
  const handleOnSort = ({ selector }, sortDirection) => {
    let keys = [];
    date.selectedValues.map((key, idx) => {
      keys.push(key.value);
    });
    // let keys = date.selectedValues
    //   .map((key, idx) => {
    //     return "categories[" + idx + "]=" + key.value;
    //   })
    //   .join("&");

    paginationchange(
      ContentData.inPage,
      ContentData.perPage,
      date?.start,
      date?.end,

      sortDirection,
      selector,
      keys
    );
  };
  const filterHandlet = (start, end, type = "") => {
    SetDate((prev) => ({
      ...prev,
      start: start,
      end: end,
      selectedValues: type,
    }));
    let keys = [];
    type.map((key, idx) => {
      keys.push(key.value);
    });

    // let keys = type
    //   .map((key, idx) => {
    //     return "categories[" + idx + "]=" + key.value;
    //   })
    //   .join("&");
    loader.EarningsTable.search = true;

    paginationchange(
      ContentData.inPage,
      ContentData.perPage,
      start,
      end,
      "",
      "",
      keys
    );
  };

  //reset handler
  const resetData = () => {
    SetDate((prev) => ({
      ...prev,
      start: moment().startOf("month").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
    }));

    loader.EarningsTable.reset = true;

    paginationchange(
      ContentData.inPage,
      ContentData.perPage,
      moment().startOf("month").format("MMMM D, YYYY"),
      moment().format("MMMM D, YYYY"),
      "",
      "",
      ""
    );
  };
  const ConvertData = (data) => {
    let newData = data.map((obj) => {
      if (obj.key) {
        return {
          ...obj,
          key: t("ewallet." + obj.key),
        };
      } else {
        return {
          ...obj,
        };
      }
    });
    return newData;
  };
  return (
    <>
      {/* {ContentData.category.length !== 0 && ( */}

      <Filter
        filterHandler={filterHandlet}
        // type={ConvertData(ContentData.category)}
        resetHandler={resetData}
        isSingle={false}
        exports={true}
        exportData={exportData}
        ContentData={ContentData}
        loader={loader}
        selectedTab={selectedTab}
        disable={true}
      />
      {/* )} */}

      <ViewDetailsModal
        show={viewDetailsModal}
        handleClose={handleClose}
        data={resultData}
        onHide={() => setViewDetailsModal(false)}
      />
      {/* <DataTableExtensions
                filter={false}
                exportHeaders={true}
                columns={columns}
                data={data}
            > */}

      <DataTable
        customStyles={customStyles}
        columns={columns}
        data={data}
        highlightOnHover
        progressPending={ContentData.pending}
        progressComponent={<div>Loading</div>}
        persistTableHead
        noHeader
        pagination
        paginationServer
        responsive
        paginationTotalRows={ContentData.totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        noDataComponent={t("Common.noDataRecordsToDisplay")}
        //onSort={handleOnSort}
      />
      {/* </DataTableExtensions> */}
    </>
  );
}

export default HistorysTable;
